import React, { useState, useRef } from 'react';
import { TextField, Button, Paper, Box, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import useApiManager from '../../../utils/Api/apiManager';
import MentionTextField from './MentionTextField';

const ExpandableTextField = ({ edit, note, fetchNotes, editHandleCancel, entity, users }) => {
    const [expanded, setExpanded] = useState(!!edit);
    const [content, setContent] = useState(note?.content || "");
    const [title, setTitle] = useState(note?.title || "");
    const [mentions, setMentions] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileName, setSelectedFileName] = useState('');
    const { post, put, del } = useApiManager();
    const params = useParams();
    // Assume the parameter is always the first one in the URL
    const paramValue = Object.values(params)[0];
    const fileInputRef = useRef(null);

    // if(edit) {
    //     setExpanded(true);
    //     setTitle(editTitle);
    //     setContent(editContent);
    // }

    const handleExpand = () => {
        setExpanded(true);
    };

    const handleCancel = () => {
        if (edit)
        {
            editHandleCancel();
        }
        setExpanded(false);
        setContent('');
        setTitle('');
        setSelectedFile(null);
        setSelectedFileName('');
    };

    const handleIconClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            setSelectedFileName(file.name);
        }
    };

    const createNote = async () => {
        const formData = new FormData();
        formData.append('attachment', selectedFile);

        // Append each mention ID separately so the backend binds to List<string>
        (mentions ?? []).forEach(m => {
            formData.append('mentionIds', m.id);
        });

        const url = `/${entity}/${paramValue}/notes`;

        const config = {
            params: {
                title,
                content
            },
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };

        try {
            await post(url, formData, config);
            handleCancel(); // Reset form after successful submission
            fetchNotes();
        } catch (error) {
            console.error('Error adding note:', error);
            // Handle error (e.g., show error message)
        }
    }

    const editNote = async () => {
        const formData = new FormData();
        formData.append('newAttachment', selectedFile);
        
        (mentions ?? []).forEach(m => {
            formData.append('mentionIds', m.id);
        });

        const url = `/${entity}/${paramValue}/notes/${note.id}`;

        const config = {
            params: {
                title,
                content
            },
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };

        try {
            await put(url, formData, config);
            handleCancel(); // Reset form after successful submission
            fetchNotes();
        } catch (error) {
            console.error('Error updating note:', error);
            // Handle error (e.g., show error message)
        }
    }

    const handleSave = async () => {
        if (!content) {
            alert("Please fill out the content field.");
            return;
        }

        if (edit) {
            editNote();
        }
        else {
            createNote();
        }
    };



    return (
        <Paper elevation={1} sx={{ border: '1px black' }}>
            {/* <TextField
                label="Add a note..."
                variant="outlined"
                value={content}
                onChange={(e) => setContent(e.target.value)}
                onClick={handleExpand}
                fullWidth
                multiline
                rows={expanded ? 4 : 1} // Adjusts the size when expanded
            /> */}


            <MentionTextField
                handleExpand={handleExpand}
                expanded={expanded}
                content={content}
                setContent={setContent}
                mentions={mentions}
                setMentions={setMentions}
                users={users}
            />

            {expanded && (
                <Paper elevation={0} style={{ padding: '10px' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <AttachFileIcon onClick={handleIconClick} style={{ cursor: 'pointer' }} />
                            <input
                                type="file"
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                                onChange={handleFileChange}
                            />
                            <TextField
                                variant='standard'
                                placeholder='Add a title'
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                InputProps={{
                                    disableUnderline: true,
                                }}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button onClick={handleCancel}>Cancel</Button>
                            <Button variant="contained" color="primary" onClick={handleSave}>
                                Save
                            </Button>
                        </Box>
                    </Box>
                    {/* Conditionally render the selected filename */}
                    {selectedFileName && (
                        <Typography variant="body2" color="textSecondary" sx={{ marginTop: 1 }}>
                            Selected file: {selectedFileName}
                        </Typography>
                    )}
                </Paper>
            )}
        </Paper>
    );
};

export default ExpandableTextField;
